
export default function Stripe(props) {
	return (
		<div className="w-100" style={{ backgroundColor: props.color, height: props.height }} />
	);
}
